import { render, staticRenderFns } from "./AbsencesList.vue?vue&type=template&id=47355e97&"
import script from "./AbsencesList.vue?vue&type=script&lang=js&"
export * from "./AbsencesList.vue?vue&type=script&lang=js&"
import style0 from "./AbsencesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports